<div class="flex flex-col justify-start items-center">
  <a [routerLink]="['/']" tabindex="-1">
    <tdv-logo class="logo-symbol cursor-pointer"></tdv-logo>
  </a>

  <nav class="mt-48">
    <a
      *ngIf="permissionsS?.accessMap.patients.list"
      mat-icon-button
      class="tdv-btn-circle tdv-btn-lg"
      [routerLink]="PATIENTS_ROUTE"
      routerLinkActive="!bg-blue"
    >
      <tdv-icon [name]="'user'"></tdv-icon>
    </a>
  </nav>
</div>

<div
  [tdvTooltip]="{
    template: tooltipTmpl,
    toggleByClick: true,
    offsetX: -20,
    placement: 'right',
    maxWidthPx: 400,
    verticalTrinagleOffsetPx: 52,
  }"
  #tooltipDirective
  (tdvTooltipToggled)="onMenuToggled($event)"
  class="flex items-center justify-center"
>
  <tdv-avatar
    [size]="40"
    [config]="authUserStateS.avatarSgnl()"
    class="app-menu-avatar-toggle"
    [ngClass]="{ 'app-menu-avatar-toggle--is-open': isOpen }"
  ></tdv-avatar>

  <ng-template #tooltipTmpl>
    <tdv-profile-tooltip (closeMe)="onCloseTooltip()"></tdv-profile-tooltip>
  </ng-template>
</div>
